export default __webpack_public_path__ + "locales/tr/ChangeUserStatusDialog.json?hash=de0b4ca1dc6da9496640b743dd5ebfbb";